import { Component, Injector, Inject, ViewChild, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidacaoRecaptchaService } from 'src/app/shared/services/validacao-recaptcha.service';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    templateUrl: './validacao-recaptcha.component.html',
    styleUrls: ['./validacao-recaptcha.component.css'],
    standalone: false
})
export class ValidacaoRecaptchaComponent implements OnInit {

  public callback: any;

  protected captchaFormGroup: UntypedFormGroup;
  public chavePublicaCaptcha: string;

  constructor(
    private activeModal: NgbActiveModal,
    private validacaoRecaptchaService: ValidacaoRecaptchaService,
    private formBuilder: UntypedFormBuilder) { 
  }

  ngOnInit() {   
    this.captchaFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });

    if (!this.chavePublicaCaptcha) {
      this.carregaChavePublicaCaptcha();
    } 
  }

  public carregaChavePublicaCaptcha() {
    this.validacaoRecaptchaService.obterChavePublicaCaptcha().subscribe(chavePublica => this.chavePublicaCaptcha = chavePublica);
  }

  public handleSuccess(tokenCaptcha) {
    this.activeModal.close(tokenCaptcha);
  }

  public handleExpire() {
  }

  public handleLoad() {
  }

  public handleReset() {
  }
}
